import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Empty_LetterRequestCustomer_Cancel, LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerDeviceBehfa',
  templateUrl: './LetterRequestCustomerDeviceBehfa.component.html',
  styleUrls: ['./LetterRequestCustomerDeviceBehfa.component.scss']
})
export class LetterRequestCustomerDeviceBehfaComponent implements OnInit {

  Token: String = ""
  Filter_Letter: string = "0"
  Filter_Dsc: string = ""
  BaseUrl2 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?id="

  Procssing: boolean = false

  modalRef_Cancel: any;

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private DeviceBehfa_Service: DeviceBehfaService,
    private modalService: BsModalService
  ) { }


  DataList_Schedules: Array<LetterRequestCustomer_Cancel> = []
  Data_Seleted_Cancel: LetterRequestCustomer_Cancel = Empty_LetterRequestCustomer_Cancel()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.BaseUrl2 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?token=" + this.Token + "&id="
    this.Nav_Service.CheckValidPage(this.Token, 1130).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  ReadData_Schedules() {
    this.Procssing = true

    this.LetterRequestCustomer_Service.GetActiveMissionByLetter(this.Token, Number(this.Filter_Letter), 0).subscribe(
      data => {
        this.DataList_Schedules = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }




  //#region Mission

  modalRef_Delete: any
  Processing_Detail: boolean = false
  Selected_Record_Schedules: LetterRequestCustomer_Cancel = Empty_LetterRequestCustomer_Cancel()

  Selected_Mission_Device: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()
  DataList_Mission_Device: Array<DeviceBehfa_Interface> = []
  DataList_Mission_Device_NoneDelete: Array<DeviceBehfa_Interface> = []
  ReadData_Mission_Device() {
    this.DataList_Mission_Device = []
    this.Processing_Detail = true
    this.LetterRequestCustomer_Service.GetActiveMissionDeviceBehfa(this.Token + '', this.Selected_Record_Schedules.id, 1).subscribe(
      data => {
        this.Processing_Detail = false
        this.DataList_Mission_Device = data

        this.DataList_Mission_Device_NoneDelete = []
        for(let item of  this.DataList_Mission_Device)
        {
          if(!item.del)
          {
            this.DataList_Mission_Device_NoneDelete.push(item)
          }
        }
        
      }
    )
  }

  set_Selected_Record_Schedules(item: LetterRequestCustomer_Cancel) {
    this.Selected_Record_Schedules = item
    this.ReadData_Mission_Device()
  }


  back_Selected_Record_Schedules() {
    this.Selected_Record_Schedules = Empty_LetterRequestCustomer_Cancel()
  }


  DeviceBehfa_Delete_Dsc: string = ''

  Delete(item: DeviceBehfa_Interface) {

    if (this.DeviceBehfa_Delete_Dsc.trim().length < 50) {
      this.Alertify_Service.ErrorMessage("Enter a description of at least 50 characters.")
    }
    else {
      this.Processing_Detail = true
      this.modalRef_Delete.hide()
      this.LetterRequestCustomer_Service.PostActiveMissionDeviceBehfaRemove(this.Token,
        item.id,
        this.DeviceBehfa_Delete_Dsc).subscribe(
          data => {
            this.DeviceBehfa_Delete_Dsc = ''
            this.Alertify_Service.SuccessMessage("Deleted successfully.")
            this.ReadData_Mission_Device()
          }, error => {
            localStorage.clear()
            location.reload();

          }
        )
    }
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Selected_Mission_Device = Record
    this.modalRef_Delete = this.modalService.show(template);
    this.DeviceBehfa_Delete_Dsc = ""
  }

  //#endregion


  //#region  Device Behfa

  modalRef_DeviceBehfa: any;

  Procssing_DeviceBehfa: boolean = false

  Search_Code_DeviceBehfa_Table: string = ''

  openModal_DeviceBehfa(template: TemplateRef<any>) {



   this.DeviceBehfa_Delete_Dsc = ""
   this.modalRef_DeviceBehfa = this.modalService.show(template);
      this.DataList_DeviceBehfa = []
 }

  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []
  //Data_Seleted_DeviceBehfa_Record: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()

  ReadData_DeviceBehfa_KeySearch_Timer: any
  ReadData_DeviceBehfa_KeySearch() {

    if (this.ReadData_DeviceBehfa_KeySearch_Timer) {
      clearTimeout(this.ReadData_DeviceBehfa_KeySearch_Timer);
      this.ReadData_DeviceBehfa_KeySearch_Timer = null;
    }

    this.ReadData_DeviceBehfa_KeySearch_Timer = setTimeout(function () {
      this.ReadData_DeviceBehfa()
    }.bind(this), 1000);

  }

  ReadData_DeviceBehfa() {


    if (!this.Search_Code_DeviceBehfa_Table) {
      this.DataList_DeviceBehfa = []


    }
    else {
      this.Procssing_DeviceBehfa = true

      this.DeviceBehfa_Service.GetSearchBehfaDeviceActive(this.Token,
        this.Search_Code_DeviceBehfa_Table,
        this.Selected_Record_Schedules.persianDate,false, 0, 0).subscribe(
          data => {

            this.DataList_DeviceBehfa = data
            this.Procssing_DeviceBehfa = false
          }, error => {
            localStorage.clear()
            location.reload();

          }
        )
    }
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    if (!this.DeviceBehfa_Delete_Dsc || this.DeviceBehfa_Delete_Dsc.trim().length < 50) {
      this.Alertify_Service.ErrorMessage("Enter a description of at least 50 characters.")
    }
    else {
      this.Processing_Detail = true
      this.LetterRequestCustomer_Service.PostActiveMissionDeviceBehfaAdd(this.Token,
        item.id,
        this.Selected_Record_Schedules.id,
        this.DeviceBehfa_Delete_Dsc).subscribe(
          data => {
            this.Processing_Detail = false
            if (data['code'] == 'yes') {
              this.DeviceBehfa_Delete_Dsc = ''
              this.Alertify_Service.SuccessMessage("The equipment was added to the assignment.")
              this.ReadData_Mission_Device()
            }
            else if (data['code'] == 'no') {
              this.Alertify_Service.ErrorMessage("The equipment is already registered for this assignment.")
            }
            else {
              this.Alertify_Service.ErrorMessage("The equipment is assigned to another assignment.")
            }
          }, error => {
            localStorage.clear()
            location.reload();

          }
        )
    }

  }

  page: 0
  //#endregion



}
